// extracted by mini-css-extract-plugin
export var headerCell = "_48-1";
export var loadingSpinnerContainer = "_48-4";
export var rowWrapper = "_48-3";
export var standaloneTable = "_48-5";
export var table = "_48-0";
export var white = "_48-2";